import { NavLink } from '@/components/NavLink';
import { BOTTOM_ITEMS, resolveNav, useUiConfig } from '@/lib/uiConfig';

export function BottomNav() {
  const items = resolveNav(useUiConfig(), BOTTOM_ITEMS);
  if (items.length === 0) return null;
  return (
    <nav className="shrink-0 z-50 border-t border-border bg-card/95 backdrop-blur pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center justify-around h-16">
        {items.map((item) => (
          <NavLink
            key={item.key}
            to={item.url}
            end={item.url === '/'}
            className="flex flex-col items-center justify-center gap-1 py-2 px-4 rounded-lg text-muted-foreground hover:text-foreground transition-colors"
            activeClassName="text-primary font-medium bg-primary/10"
          >
            <item.Icon className="w-5 h-5" />
            <span className="text-[10px]">{item.title}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
